import EATable from "../../EATable";
import React from "react";
import {createCalculatedColumn, createColumn, createComponentColumn} from "../../../utils/ColumnUtils";
import {useHttp} from "../../../services/HttpService";
import EABetriebsakteMainContainer from "../EABetriebsakteMainContainer";
import {createCustomTextLink} from "../../../utils/RouteUtils";
import {JAHRESBERICHT} from "../../../consts/fachobjekt";
import {useHistory} from "react-router-dom";
import {
    getJahresberichtEndpoint
} from "../../../services/AnlagenService";
import "../../../styles/components/entlastungUebersicht.css";
import {formatDate} from "../../../utils/DateUtils";
import {parseISO} from "date-fns";
import CircularProgress from "@material-ui/core/CircularProgress";
import {JahresberichtValues} from "../../../consts/valueLists";

export default function JahresberichtUebersicht(props) {
    const history = useHistory();

    const [{
        data: jahresberichtData,
        loading: jahresberichtDataLoading
    }, refreshJahresberichtData] = useHttp(getJahresberichtEndpoint(props.betriebId));

    const linkColumnComponentProvider = (row) => createCustomTextLink(row.anlage.anlagenId, JAHRESBERICHT, row.id, history);

    if (isReloadParameterSet()) {
        refreshJahresberichtData();
    }

    function isReloadParameterSet() {
        const params = new URLSearchParams(window.location.search);
        const reloadValue = params.get("reload");

        params.delete("reload");
        const newUrl = window.location.pathname + params.toString();
        window.history.replaceState({}, "", newUrl);

        return reloadValue === "true";
    }

    const getStatusValue = (id) => {
        const statusObj = JahresberichtValues.find((status) => status.id === id);
        return statusObj ? statusObj.value : "";
    };

    const columns = [
        createCalculatedColumn(
            "berichtsjahr",
            (row) => (row?.von ? new Date(row.von).getFullYear() : null),
            "Berichtsjahr"
        ),

        createComponentColumn("anlage.anlagenId",linkColumnComponentProvider , "Anlagen-Nr."),
        createColumn("anlage.bezeichnung", "Anlagen-Name"),
        createCalculatedColumn(
            "von",
            (row) => (row?.von ? formatDate(parseISO(row.von)) : null),
            "Von"
        ),
        createCalculatedColumn(
            "bis",
            (row) => (row?.bis ? formatDate(parseISO(row.bis)) : null),
            "Bis"
        ),
        createCalculatedColumn(
            "status",
            (row) => getStatusValue(row.status),
            "Status"
        ),
        createCalculatedColumn(
            "geaendert",
            (row) => (row?.geaendert ? formatDate(parseISO(row.geaendert)) : null),
            "Geändert"
        ),
        createColumn("eingereichtVon.person.name", "Eingereicht von"),
    ];

    const columnsBemerkung = [
        createColumn("bemerkung", "Bemerkung"),
    ];

    const jahreData = [];
    const bemerkungenData = [];
    if (jahresberichtData) {
        jahresberichtData.forEach(row => {
            if (row.von) {
                jahreData.push(row);
            }
            if (row.bemerkung) {
                bemerkungenData.push(row);
            }
        });
    }

    return (
        <div className={"viewScrollContainer"}>
            <EABetriebsakteMainContainer className={"tabsheet-content-margin"}>
                {jahresberichtDataLoading ? (
                    <div style={{display: 'flex', justifyContent: 'center', height: '100vh'}}>
                        <CircularProgress/>
                    </div>
                ) : (
                    jahreData.map((yearRow, index) => (
                        <React.Fragment key={`year-table-${index}`}>
                            <EATable columns={columns} data={[yearRow]} loading={jahresberichtDataLoading} />
                            {bemerkungenData[index] && (
                                <EATable columns={columnsBemerkung} data={[bemerkungenData[index]]} loading={jahresberichtDataLoading} />
                            )}
                            {index < jahreData.length - 1 && <div style={{ marginBottom: "20px" }} />}
                        </React.Fragment>
                    ))
                )}
            </EABetriebsakteMainContainer>
        </div>
    );
}